import React from "react"

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom"

import Home from "../pages/home"
import Atendimentocheckup from "../pages/atendimento-checkup"
import Atendimentoclinicas from "../pages/atendimento-clinicas"
import Compliance from "../pages/compliance"
import Leitoscentrocirurgico from "../pages/leitos-centrocirurgico"
import Limpeza from "../pages/limpeza"
import Grato from "../pages/grato"
import Temperatura from "../pages/temperatura"
import Privacidade from "../pages/privacidade"
import Lgpd from "../pages/lgpd"
import Quemsomos from "../pages/quem-somos"
import Ativos from "../pages/ativos"
import Rfid from "../pages/rfid"
import Contato from "../pages/contato"


const Rotas = () => (
  <BrowserRouter>
    <Routes>

      {/* extra screens */}
      <Route path="/home" element={<Home />} />
      <Route path="/" element={<Home />} />

      <Route path="/atendimento-de-check-up" element={<Atendimentocheckup />} />
      <Route path="/atendimento-clinicas" element={<Atendimentoclinicas />} />
      <Route path="/leitos-e-centros-cirurgicos" element={<Leitoscentrocirurgico />} />
      <Route path="/limpeza" element={<Limpeza />} />
      <Route path="/temperatura" element={<Temperatura />} />
      <Route path="/ativos" element={<Ativos />} />
      <Route path="/rfid" element={<Rfid />} />
      <Route path="/contato" element={<Contato />} />

      <Route path="/compliance" element={<Compliance />} />
      <Route path="/grato" element={<Grato />} />
      <Route path="/privacidade" element={<Privacidade />} />
      <Route path="/lgpd" element={<Lgpd />} />
      <Route path="/quem-somos" element={<Quemsomos />} />

      <Route path="http://www.itechmed.com.br/home" element={<Home />} />
      <Route path="http://www.itechmed.com.br/" element={<Home />} />

      <Route path="http://www.itechmed.com.br/atendimento-de-check-up" element={<Atendimentocheckup />} />
      <Route path="http://www.itechmed.com.br/atendimento-clinicas" element={<Atendimentoclinicas />} />
      <Route path="http://www.itechmed.com.br/leitos-e-centros-cirurgicos" element={<Leitoscentrocirurgico />} />
      <Route path="http://www.itechmed.com.br/limpeza" element={<Limpeza />} />
      <Route path="http://www.itechmed.com.br/temperatura" element={<Temperatura />} />
      <Route path="http://www.itechmed.com.br/ativos" element={<Ativos />} />
      <Route path="http://www.itechmed.com.br/rfid" element={<Rfid />} />
      <Route path="http://www.itechmed.com.br/contato" element={<Contato />} />

      <Route path="http://www.itechmed.com.br/compliance" element={<Compliance />} />
      <Route path="http://www.itechmed.com.br/grato" element={<Grato />} />
      <Route path="http://www.itechmed.com.br/privacidade" element={<Privacidade />} />
      <Route path="http://www.itechmed.com.br/lgpd" element={<Lgpd />} />
      <Route path="http://www.itechmed.com.br/quem-somos" element={<Quemsomos />} />

      <Route path="https://www.itechmed.com.br/home" element={<Home />} />
      <Route path="https://www.itechmed.com.br/" element={<Home />} />

      <Route path="https://www.itechmed.com.br/atendimento-de-check-up" element={<Atendimentocheckup />} />
      <Route path="https://www.itechmed.com.br/atendimento-clinicas" element={<Atendimentoclinicas />} />
      <Route path="https://www.itechmed.com.br/leitos-e-centros-cirurgicos" element={<Leitoscentrocirurgico />} />
      <Route path="https://www.itechmed.com.br/limpeza" element={<Limpeza />} />
      <Route path="https://www.itechmed.com.br/temperatura" element={<Temperatura />} />
      <Route path="https://www.itechmed.com.br/ativos" element={<Ativos />} />
      <Route path="https://www.itechmed.com.br/rfid" element={<Rfid />} />
      <Route path="https://www.itechmed.com.br/contato" element={<Contato />} />

      <Route path="https://www.itechmed.com.br/compliance" element={<Compliance />} />
      <Route path="https://www.itechmed.com.br/grato" element={<Grato />} />
      <Route path="https://www.itechmed.com.br/privacidade" element={<Privacidade />} />
      <Route path="https://www.itechmed.com.br/lgpd" element={<Lgpd />} />
      <Route path="https://www.itechmed.com.br/quem-somos" element={<Quemsomos />} />

      {/* exception router */}
      <Route path="*" render={() => (
        <Navigate to={'/home'} />
      )} />
    </Routes>
  </BrowserRouter>
)

export default Rotas